module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/5Dj8bB3BRWvbbeeuQeU4MX-77624bd9b9c892612caee1829512ad3f.jpg";